import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NetworkLostError } from './graph-errors';

/**
 * Rethrows a status-0 failure on a GraphQL request as a typed `NetworkLostError`,
 * which survives apollo-angular 14 untouched (it only rewraps `HttpErrorResponse`).
 */
@Injectable()
export class NetworkLostInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((err: unknown) =>
        throwError(() =>
          req.url.includes('graphql') && err instanceof HttpErrorResponse && err.status === 0
            ? new NetworkLostError(err.message)
            : err
        )
      )
    );
  }
}
